import React from 'react';
import { JointHealthPage } from './pages/JointHealthPage';
export function App() {
  return <JointHealthPage data-id="element-0" />;
}